import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { MailService } from 'src/app/Shared/Mail/mail.service';
import { MovesService } from 'src/app/Shared/MoveService/moves.service';
import { UserDetailsService } from 'src/app/Shared/UserDetails/user-details.service';
import { MailboxVM } from 'src/app/ViewModels/Email';

@Component({
  selector: 'app-archive-mails',
  templateUrl: './archive-mails.component.html',
  styleUrls: ['./archive-mails.component.css']
})
export class ArchiveMailsComponent implements OnInit {
  public isLoggedIn: boolean = false;
  uid: string;
  roleid: string;
  userName: string;
  usermail: string;
  pid: string;
  gridvalue: string;
  GUID: string;
  DateTime: Date;
  archiveList: any;
  q: number = 1;
  p: number = 1;
  searchText: any;
  selectedSelected: any = [];
  folderCreating: boolean;
  n: number;
  num: any;
  createdmsg: string;
  notify: string;
  CurrentFiles: any;
  inboxm: string;
  sentm: string;
  
  constructor(private router: ActivatedRoute, private userservice: UserDetailsService, private moveService: MovesService,
    private route: Router, private httpService: HttpClient, private modalService: NgbModal,
    private spinner: NgxSpinnerService, private datepipe: DatePipe, private http: HttpClient, 
    private mailservice: MailService) {
       
    
      if (localStorage.getItem("IsLoggedIn") == "true") {
      this.isLoggedIn = true;
      this.uid = localStorage.getItem("userId");
      this.roleid = localStorage.getItem("role");
      this.userName = localStorage.getItem("UserName");
      this.pid = localStorage.getItem("parentid");
      this.usermail = localStorage.getItem("MailId");
      this.gridvalue = localStorage.getItem("gridvalue");
      this.GUID = localStorage.getItem("GUID");
    }
  }

  ngOnInit(): void {
    this.GetarchiveMailList();
  }

  inbox() {
    this.route.navigate(['inboxmails']);
  }
  composemail() {
    this.route.navigate(['composemsg']);
  }
  deleteitems() {
    this.route.navigate(['del']);
  }
  sentitems() {
    this.route.navigate(['sentmails']);
  }
  archiveitems() {
    this.route.navigate(['archive']);
  }

  GetarchiveMailList() {
    this.spinner.show();
    var info ={
      UID  :this.uid
    }
    this.mailservice.getarchivelist(info).subscribe((respose: any) => {
      this.archiveList = respose;
      var res = this.archiveList.sort((a,b)=> b.epochtime-a.epochtime)
      console.log(res);
      console.log(respose);
      this.spinner.hide(); 
    });
  }

  ReadMessage(data) {
    localStorage.setItem('fromuser', data.From);
    localStorage.setItem('touser', data.To);
    localStorage.setItem('attachments', data.Attachments);
    localStorage.setItem('mailid', data.MasId);
    localStorage.setItem('transid', data.TransId);
    localStorage.setItem('maildate', data.DateforRM);
    localStorage.setItem('profilepic', data.UserProfilePic);
    localStorage.setItem('firstletter', data.FirstLetter);
    localStorage.setItem('docname', data.DocumentName);
    localStorage.setItem('emailbody', data.EmailBody);
    localStorage.setItem('sub', data.Subject); 
    if(data.checkname == "inbox"){
      this.inboxm = 'inbox-' + data.mailId;
      this.route.navigate(['readmsg/'+ this.inboxm ]);
    }
    else if(data.checkname == "sent"){
      this.sentm = 'sent-' + data.mailId;
      this.route.navigate(['readmsg/'+ this.sentm ]);
    }
  }
  sort = "1";

  sortby() {
    if (this.sort == "1") {
      this.archiveList.sort((a, b) => a.fromName.toLowerCase() < b.fromName.toLowerCase() ? -1 : a.fromName.toLowerCase() > b.fromName.toLowerCase() ? 1 : 0)
      this.sort = "2";
    }
    else if (this.sort == "2") {
      this.archiveList.sort((a, b) => a.fromName.toLowerCase() > b.fromName.toLowerCase() ? -1 : a.fromName.toLowerCase() < b.fromName.toLowerCase() ? 1 : 0)
      this.sort = "1";

    }

  }
  sortname = "1";
  sortbydate() {
    if (this.sortname == "1") {
      this.archiveList.sort((a, b) => a.Sortdate < b.Sortdate ? -1 : a.Sortdate > b.Sortdate ? 1 : 0)
      this.sortname = "2";
    }
    else if (this.sortname == "2") {
      this.archiveList.sort((a, b) => a.Sortdate > b.Sortdate ? -1 : a.Sortdate < b.Sortdate ? 1 : 0)
      this.sortname = "1";

    }

  }

  toggleSelect(data) {
    this.CurrentFiles = data;
    if (data != null) {
      if (this.selectedSelected.length == 0) {
        this.selectedSelected.push(data);
      }
      else {
        const index = this.selectedSelected.indexOf(data, 0);
        if (index > -1) {
          this.selectedSelected.splice(index, 1);
        }
        else {
          this.selectedSelected.push(data); 
        }
      }
    }  
  }

  
  singleDelete(data){
    this.selectedSelected.push(data);
    this.multidelete();
  }
  multidelete() {
    this.DateTime = new Date();
    let latest_date = this.datepipe.transform(this.DateTime, 'dd-MM-yyyy hh:mm:ss a');
    // this.showper = true;
    // this.generalprogressbar = true;
    this.folderCreating = true;
    const inputRequest1: MailboxVM = {
      Fromuser:this.uid,
      MailsList:this.selectedSelected,
      CurrentDate:latest_date
    }
    this.mailservice.multideletemsgs(inputRequest1).subscribe((respose: any) => {
      if(respose == "1"){
        this.n=100;
        this.notify = "Deleted Successfully...!"
        this.GetarchiveMailList();
        this.folderCreating = false;
        this.selectedSelected = [];
    
        clearInterval(this.num);

        setTimeout(function () {
          this.folderCreating = false;
          this.foldercreated = false;
          this.generalprogressbar = false;
          this.errormsg = false;
          this.showper = false;
          this.n=10;
        }.bind(this), 3000);
        this.GetarchiveMailList();
    }
    else{
      this.selectedSelected = [];
      this.GetarchiveMailList();
 
    }
    });
  }

  restore(data){
    this.selectedSelected.push(data);
    this.multirestore();
  }
  multirestore() {
    this.DateTime = new Date();
    let latest_date = this.datepipe.transform(this.DateTime, 'dd-MM-yyyy hh:mm:ss a');
    const inputRequest1: MailboxVM = {
      Fromuser:this.uid,
      MailsList:this.selectedSelected,
      CurrentDate:latest_date
    }
    this.mailservice.restoredeletemessages(inputRequest1).subscribe((respose: any) => {
      if(respose == "1"){
        this.n=100;
        this.createdmsg = "Archived Successfully...!"
        this.folderCreating = false;
        this.selectedSelected = [];
        clearInterval(this.num);

        setTimeout(function () {
          this.folderCreating = false;
          this.foldercreated = false;
          this.generalprogressbar = false;
          this.errormsg = false;
          this.showper = false;
          this.n=10;
        }.bind(this), 3000);
      this.GetarchiveMailList();
     
    }
    else{
      this.selectedSelected = [];
    this.GetarchiveMailList();
   
    }
    });
  }
}
